export const apiVersion = '/api/v1';

type EntityId = number | string;

export const API_REGISTRATION = `${apiVersion}/registrations`;

export const API_RISK_ASSESSMENT = `${apiVersion}/risk-assessment`;
export const API_RISK_ASSESSMENT_GENERATE = (caseId: EntityId) =>
  `${apiVersion}/risk-assessment/${caseId}/generate`;
